<template>
  <!-- 删除 区块弹窗-->
  <BaseDialog :value="value" class="remove-block-dialog" width="448px" type="warning" :modal="true" :offset="[56,0,0,0]" :modal-append-to-body="true" :append-to-body="true" :title="title" @close="close" @change="close">
    <div class="remove-block__body">
      <div class="warning-title text-16 text-white text-center mb-[30px]">
        是否{{ title }}，如删除将丢弃该内容
      </div>
    </div>
    <div class="remove-block_footer flex justify-end gap-4">
      <BaseButton @click.stop="close">保留</BaseButton>
      <BaseButton type="danger" @click.stop="deleteBlock">删除</BaseButton>
    </div>
  </BaseDialog>
</template>

<script>
import BaseDialog from '~/components/base/baseDialog'
import BaseButton from '~/components/base/BaseButton'

export default {
  name: "DeleteBlockDialog",
  components:{
    BaseDialog,
    BaseButton
  },
  model:{
    prop: 'value',
    event: 'change'
  },
  props:{
    title: {
      type: String,
      default: '删除区块'
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    close(){
      this.$emit('change',false)
    },
    deleteBlock(){
      this.$emit('delete-block')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
